// Arranque/reanudación de la Session Replay de Mixpanel. Ver issue #149.
//
// Dos usos:
// - Arranque inmediato en /invite/{token} (startSessionReplay), en cuanto se
//   monta la página, antes del login.
// - Arranque puntual en la landing DE (baby-wunschliste-v2), solo si el
//   usuario llega a registrarse: la landing marca el origen con
//   markReplaySource y MixPanelUserLogin.js lo consume con
//   consumeReplaySource + startSessionReplay al hacer login.
//
// resumeSessionReplay reactiva la grabación tras una recarga completa de
// página (vuelta de /auth/google o /auth/apple), si esta pestaña ya estaba
// grabando.
//
// Todas las sesiones que arrancan se graban (sin límite de una vez por
// navegador), con los textos e imágenes visibles: los inputs siguen
// enmascarados por defecto, y password/email/tel siempre se enmascaran pase
// lo que pase, eso no lo controla record_mask_all_text.

const ACTIVE_KEY = "mp_replay_active";
const PENDING_SOURCE_KEY = "mp_replay_source";

// Hasta la issue #149 la landing DE solo grababa una vez por navegador,
// marcado con esta clave. Se limpia para que esos navegadores vuelvan a
// grabarse como cualquier otro, ahora que ya no hay límite.
try {
  if (typeof window !== "undefined") localStorage.removeItem("mp_replay_recorded");
} catch (e) { /* storage no disponible */ }

// El snippet de Mixpanel no encola start_session_recording mientras la
// librería real no ha cargado (a diferencia de track/identify/etc.), así que
// si se llama demasiado pronto la llamada se pierde en silencio. Reintenta
// unos segundos en vez de asumir que ya está cargada.
function whenReady(callback) {
  if (typeof window === "undefined") return;
  if (typeof window.mixpanel?.start_session_recording === "function") {
    callback();
    return;
  }
  let attempts = 0;
  const interval = setInterval(() => {
    attempts += 1;
    if (typeof window.mixpanel?.start_session_recording === "function") {
      clearInterval(interval);
      callback();
    } else if (attempts >= 20) { // ~5s
      clearInterval(interval);
    }
  }, 250);
}

function activateReplay(source) {
  whenReady(() => {
    try {
      window.mixpanel.set_config({
        record_mask_all_text: false,
        record_block_selector: "",
      });
      window.mixpanel.start_session_recording();
      window.mixpanel.track("Session Replay iniciada", { source });
    } catch (e) { /* mixpanel no disponible */ }
  });
}

export function startSessionReplay(source) {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(ACTIVE_KEY, source);
  } catch (e) { /* storage no disponible */ }
  activateReplay(source);
}

export function resumeSessionReplay() {
  if (typeof window === "undefined") return;
  try {
    const source = sessionStorage.getItem(ACTIVE_KEY);
    if (source) activateReplay(source);
  } catch (e) { /* storage no disponible */ }
}

export function markReplaySource(source) {
  if (typeof window === "undefined") return;
  try {
    if (!sessionStorage.getItem(PENDING_SOURCE_KEY)) {
      sessionStorage.setItem(PENDING_SOURCE_KEY, source);
    }
  } catch (e) { /* storage no disponible */ }
}

export function consumeReplaySource() {
  if (typeof window === "undefined") return null;
  try {
    const source = sessionStorage.getItem(PENDING_SOURCE_KEY);
    if (source) sessionStorage.removeItem(PENDING_SOURCE_KEY);
    return source;
  } catch (e) {
    return null;
  }
}
